import Vue from 'vue'
import App from './App.vue'
import router from "./router/router"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import swiper from "swiper";
// Vue.use(router,swiper)
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css' // 你可以选择其他的主题
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor /* { default global options } */)
Vue.use(ElementUI)

import {
  get,
  post,
  json,
  download
} from "./util/js/http"
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$json = json;
Vue.prototype.$download = download;
Vue.prototype.$imgUrl = 'http://rhs.cdwomen.net/prod-api'

Vue.config.productionTip = false
Vue.filter('truncate', function(value, length) {
  if (value.length > length) {
    return value.slice(0, length) ;
  } else {
    return value;
  }
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
